import dayjs from "dayjs";
import "dayjs/locale/en-gb";

dayjs.locale("en-gb");

export { dayjs };
export default dayjs;
